// @ts-strict-ignore
// @ts-strict-ignore
import { memo } from 'react'

import Flex from '@/shared/ui/Flex'

import { VariantsGroup } from '../variants-group/VariantsGroup'

import { ProductColors } from './product-colors/product-colors'

import styles from './product-variants.module.scss'

type TCrossLinksGroup = {
	name: string
	type: string
	values: TCrossLink[]
}

type TCrossLink = {
	kod: string
	value: string
	label: string
	is_current: boolean
	hash: string
	in_stock: string
}

export type ProductVariantsProps = {
	crossLinks?: TCrossLinksGroup[]
}

export enum ProductProperties {
	Color = `color`,
	OtherSpecs = `string`
}

/**
 * Product variants links
 * @param props
 * @param props.crossLinks - array of specs related products
 */
export const ProductVariants = memo(
	({ crossLinks }: ProductVariantsProps): JSX.Element => (
		<div className={styles.productVariantsWrap}>
			{crossLinks.map(({ name, values, type }) =>
				ProductProperties.Color === type
					? values.length > 1 && <ProductColors groupName={name} values={values} key={name} />
					: values.length > 1 && (
							<nav key={name} className={styles.productVariants}>
								<Flex className="variantBlock" alignCenter wrap>
									<VariantsGroup groupName={name} variants={values} />
								</Flex>
							</nav>
					  )
			)}
		</div>
	)
)
